// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container and Background */
.event-container {
    position: relative;
    width: 100%;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000;
    overflow: hidden;
}
  
.stardust-background {
    background: #000 url('https://www.transparenttextures.com/patterns/stardust.png') repeat top center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    z-index: 0;
    animation: stardustAnimation 200s linear infinite;
}

/* Animation for the stardust background */
@keyframes stardustAnimation {
    from { background-position: 0 0; }
    to { background-position: -10000px 5000px; }
}

/* Flyer Container */
.flyer-container {
    position: relative;
    width: 300px;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    overflow: hidden;
    z-index: 1;
    animation: float 6s ease-in-out infinite;
    margin: 0 auto;
}

/* Flyer Image with Glass Effect and Shine */
.flyer-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
    position: relative;
    filter: brightness(1.2) contrast(1.1);
}

@keyframes shine {
    0% {
        transform: translateX(-100%) rotate(45deg);
    }
    100% {
        transform: translateX(100%) rotate(45deg);
    }
}

/* Float animation for the flyer */
@keyframes float {
    0%, 100% {
        transform: translateY(-10px);
    }
    50% {
        transform: translateY(10px);
    }
}

/* Shooting Star Effect */
.stardust-background::after {
    content: '';
    position: absolute;
    width: 2px;
    height: 100px;
    background: linear-gradient(45deg, white, transparent);
    top: -100px;
    left: 50%;
    opacity: 0.8;
    transform: rotate(45deg);
    animation: shootingStar 2s ease-in-out infinite;
}

@keyframes shootingStar {
    0% {
        top: -100px;
        left: 50%;
        opacity: 0.8;
    }
    100% {
        top: 100%;
        left: 0;
        opacity: 0;
    }
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .flyer-container {
        width: 250px;
        height: 350px;
    }
  
    /* Mobile adjustments for the shooting star */
    .stardust-background::after {
        width: 3px; /* Increased width for mobile */
        height: 120px; /* Increased height for a larger tail */
        background: linear-gradient(135deg, white, transparent); /* Adjust gradient to match direction */
        animation: shootingStarMobile 3s ease-in-out infinite;
        transform: rotate(200deg); /* Rotate the star tail to match flight direction */
    }
}

@media (max-width: 480px) {
    .flyer-container {
        width: 200px;
        height: 300px;
    }
  
    /* Further adjustments for smaller screens */
    .stardust-background::after {
        width: 3px; /* Slightly thicker for visibility */
        height: 100px; /* Slightly larger tail for smaller screens */
        background: linear-gradient(135deg, white, transparent);
        animation: shootingStarMobile 4s ease-in-out infinite;
        transform: rotate(200deg);
    }
}

/* Modified animation for mobile shooting star */
@keyframes shootingStarMobile {
    0% {
        top: -100px;
        left: 60%;
        opacity: 0.7;
    }
    100% {
        top: 100%;
        left: 10%;
        opacity: 0;
    }
}

.event-title {
    position: relative;
    z-index: 2;
    font-size: 1.5rem;
    color: #fff;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 3px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.7), 0 0 20px rgba(255, 255, 255, 0.5), 0 0 30px rgba(255, 255, 255, 0.3);
    animation: titleGlow 4s ease-in-out infinite;
}

.event-date {
    position: relative;
    z-index: 2;
    font-size: 1rem;
    color: #fff;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 3px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.7), 0 0 20px rgba(255, 255, 255, 0.5), 0 0 30px rgba(255, 255, 255, 0.3);
    animation: titleGlow 4s ease-in-out infinite;
}

/* Modal overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

/* Modal content for full-screen image */
.modal-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden; /* Verhindert, dass Inhalte den Rahmen verlassen */
    padding: 10px;
}

.modal-image {
    width: auto; /* Automatische Breite basierend auf der Höhe */
    height: auto; /* Automatische Höhe */
    max-width: 100%; /* Maximal 100% der Modal-Breite */
    max-height: 100%; /* Maximal 100% der Modal-Höhe */
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
    object-fit: contain; /* Hält das Seitenverhältnis bei und passt in den verfügbaren Platz */
}

.modal-close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 2rem;
    color: white;
    background: transparent;
    border: none;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/components/EventSpecial.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mGAAmG;IACnG,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,iDAAiD;AACrD;;AAEA,0CAA0C;AAC1C;IACI,OAAO,wBAAwB,EAAE;IACjC,KAAK,oCAAoC,EAAE;AAC/C;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,yCAAyC;IACzC,mCAA2B;YAA3B,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU;IACV,wCAAwC;IACxC,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA,kCAAkC;AAClC;IACI;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sDAAsD;IACtD,WAAW;IACX,SAAS;IACT,YAAY;IACZ,wBAAwB;IACxB,+CAA+C;AACnD;;AAEA;IACI;QACI,WAAW;QACX,SAAS;QACT,YAAY;IAChB;IACA;QACI,SAAS;QACT,OAAO;QACP,UAAU;IACd;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA,6CAA6C;IAC7C;QACI,UAAU,EAAE,+BAA+B;QAC3C,aAAa,EAAE,uCAAuC;QACtD,uDAAuD,EAAE,uCAAuC;QAChG,qDAAqD;QACrD,yBAAyB,EAAE,mDAAmD;IAClF;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA,4CAA4C;IAC5C;QACI,UAAU,EAAE,oCAAoC;QAChD,aAAa,EAAE,6CAA6C;QAC5D,uDAAuD;QACvD,qDAAqD;QACrD,yBAAyB;IAC7B;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,WAAW;QACX,SAAS;QACT,YAAY;IAChB;IACA;QACI,SAAS;QACT,SAAS;QACT,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,oHAAoH;IACpH,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,oHAAoH;IACpH,4CAA4C;AAChD;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB,EAAE,kDAAkD;IACpE,aAAa;AACjB;;AAEA;IACI,WAAW,EAAE,+CAA+C;IAC5D,YAAY,EAAE,sBAAsB;IACpC,eAAe,EAAE,kCAAkC;IACnD,gBAAgB,EAAE,gCAAgC;IAClD,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB,EAAE,qEAAqE;AAC9F;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB","sourcesContent":["/* Container and Background */\r\n.event-container {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 70vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #000;\r\n    overflow: hidden;\r\n}\r\n  \r\n.stardust-background {\r\n    background: #000 url('https://www.transparenttextures.com/patterns/stardust.png') repeat top center;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-size: cover;\r\n    z-index: 0;\r\n    animation: stardustAnimation 200s linear infinite;\r\n}\r\n\r\n/* Animation for the stardust background */\r\n@keyframes stardustAnimation {\r\n    from { background-position: 0 0; }\r\n    to { background-position: -10000px 5000px; }\r\n}\r\n\r\n/* Flyer Container */\r\n.flyer-container {\r\n    position: relative;\r\n    width: 300px;\r\n    height: 400px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 15px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\r\n    backdrop-filter: blur(10px);\r\n    overflow: hidden;\r\n    z-index: 1;\r\n    animation: float 6s ease-in-out infinite;\r\n    margin: 0 auto;\r\n}\r\n\r\n/* Flyer Image with Glass Effect and Shine */\r\n.flyer-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border-radius: 15px;\r\n    position: relative;\r\n    filter: brightness(1.2) contrast(1.1);\r\n}\r\n\r\n@keyframes shine {\r\n    0% {\r\n        transform: translateX(-100%) rotate(45deg);\r\n    }\r\n    100% {\r\n        transform: translateX(100%) rotate(45deg);\r\n    }\r\n}\r\n\r\n/* Float animation for the flyer */\r\n@keyframes float {\r\n    0%, 100% {\r\n        transform: translateY(-10px);\r\n    }\r\n    50% {\r\n        transform: translateY(10px);\r\n    }\r\n}\r\n\r\n/* Shooting Star Effect */\r\n.stardust-background::after {\r\n    content: '';\r\n    position: absolute;\r\n    width: 2px;\r\n    height: 100px;\r\n    background: linear-gradient(45deg, white, transparent);\r\n    top: -100px;\r\n    left: 50%;\r\n    opacity: 0.8;\r\n    transform: rotate(45deg);\r\n    animation: shootingStar 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes shootingStar {\r\n    0% {\r\n        top: -100px;\r\n        left: 50%;\r\n        opacity: 0.8;\r\n    }\r\n    100% {\r\n        top: 100%;\r\n        left: 0;\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n    .flyer-container {\r\n        width: 250px;\r\n        height: 350px;\r\n    }\r\n  \r\n    /* Mobile adjustments for the shooting star */\r\n    .stardust-background::after {\r\n        width: 3px; /* Increased width for mobile */\r\n        height: 120px; /* Increased height for a larger tail */\r\n        background: linear-gradient(135deg, white, transparent); /* Adjust gradient to match direction */\r\n        animation: shootingStarMobile 3s ease-in-out infinite;\r\n        transform: rotate(200deg); /* Rotate the star tail to match flight direction */\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .flyer-container {\r\n        width: 200px;\r\n        height: 300px;\r\n    }\r\n  \r\n    /* Further adjustments for smaller screens */\r\n    .stardust-background::after {\r\n        width: 3px; /* Slightly thicker for visibility */\r\n        height: 100px; /* Slightly larger tail for smaller screens */\r\n        background: linear-gradient(135deg, white, transparent);\r\n        animation: shootingStarMobile 4s ease-in-out infinite;\r\n        transform: rotate(200deg);\r\n    }\r\n}\r\n\r\n/* Modified animation for mobile shooting star */\r\n@keyframes shootingStarMobile {\r\n    0% {\r\n        top: -100px;\r\n        left: 60%;\r\n        opacity: 0.7;\r\n    }\r\n    100% {\r\n        top: 100%;\r\n        left: 10%;\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.event-title {\r\n    position: relative;\r\n    z-index: 2;\r\n    font-size: 1.5rem;\r\n    color: #fff;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    margin-bottom: 20px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 3px;\r\n    text-shadow: 0 0 10px rgba(255, 255, 255, 0.7), 0 0 20px rgba(255, 255, 255, 0.5), 0 0 30px rgba(255, 255, 255, 0.3);\r\n    animation: titleGlow 4s ease-in-out infinite;\r\n}\r\n\r\n.event-date {\r\n    position: relative;\r\n    z-index: 2;\r\n    font-size: 1rem;\r\n    color: #fff;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    margin-bottom: 20px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 3px;\r\n    text-shadow: 0 0 10px rgba(255, 255, 255, 0.7), 0 0 20px rgba(255, 255, 255, 0.5), 0 0 30px rgba(255, 255, 255, 0.3);\r\n    animation: titleGlow 4s ease-in-out infinite;\r\n}\r\n\r\n/* Modal overlay */\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 10;\r\n}\r\n\r\n/* Modal content for full-screen image */\r\n.modal-content {\r\n    position: relative;\r\n    max-width: 90%;\r\n    max-height: 90%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    overflow: hidden; /* Verhindert, dass Inhalte den Rahmen verlassen */\r\n    padding: 10px;\r\n}\r\n\r\n.modal-image {\r\n    width: auto; /* Automatische Breite basierend auf der Höhe */\r\n    height: auto; /* Automatische Höhe */\r\n    max-width: 100%; /* Maximal 100% der Modal-Breite */\r\n    max-height: 100%; /* Maximal 100% der Modal-Höhe */\r\n    border-radius: 10px;\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);\r\n    object-fit: contain; /* Hält das Seitenverhältnis bei und passt in den verfügbaren Platz */\r\n}\r\n\r\n.modal-close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    font-size: 2rem;\r\n    color: white;\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
